

import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./AuthContext";
import { HashRouter } from "react-router-dom";
import App from "./App";
import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.min.css';


// Create the root element and render the app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HashRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </HashRouter>
);